var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHomeGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666959 7.59997L7.00013 1L13.3334 7.59997L11.8001 6.00211V11.9333C11.8001 12.2162 11.6878 12.4875 11.4877 12.6876C11.2877 12.8876 11.0164 13 10.7335 13H3.2668C2.98391 13 2.7126 12.8876 2.51256 12.6876C2.31252 12.4875 2.20014 12.2162 2.20014 11.9333V6.01101L0.666959 7.59997Z",
    stroke: "#585A5B",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHomeGrey);
export default __webpack_public_path__ + "static/media/icon_home_grey.254365a7f9cb0667e414dd4863f9b7f4.svg";
export { ForwardRef as ReactComponent };